import DataCard from 'components/data-card/data-card.component';
import { t } from 'i18next';

type CustomerLoyaltyPointsProps = {
  confirmedPoints: number;
};

const CustomerLoyaltyPoints = ({
  confirmedPoints,
}: CustomerLoyaltyPointsProps) => {
  return (
    <DataCard
      title={t('page.customers.overview.currentLoyalty')}
      value={confirmedPoints ?? 0}
      valueType="number"
    />
  );
};

export default CustomerLoyaltyPoints;
